import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { CouponDto } from './useListCoupons';

export type CouponUserAssignment = {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    usageCount: number;
    maxUsagePerUser: number;
    assignedAt: string;
};

export type CouponDetailDto = CouponDto & {
    userCoupons: CouponUserAssignment[];
};

export const GET_COUPON_QUERY_KEY = (couponId: string) => ['coupon', couponId];

export const useGetCoupon = (couponId?: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_COUPON_QUERY_KEY(couponId!),
        queryFn: () =>
            client.fetchApi<CouponDetailDto, {}>({
                endpoint: `coupons/admin/detail/${couponId}`,
                method: 'GET',
            }),
        enabled: !!couponId,
    });
};
